import store from '@/store'
import router from './router'
import NoData from './components/blocks/no-data'
import Vue from 'vue'

export default function($store) {
  const $router = router($store)
  Vue.component('NoData', NoData)
  return {
    router: $router,
    store: store
  }
}
